/** `GET /api/config` (A2), loaded once per page for the auth and profile chunks. */
import type { PublicConfig } from '@tarock/protocol';
import { api } from '../net/api';

let pending: Promise<PublicConfig | null> | null = null;

/** The public configuration, or null offline. */
export function publicConfig(): Promise<PublicConfig | null> {
  pending ??= api<PublicConfig>('/api/config').then((r) => (r.ok ? r.data : null));
  return pending;
}
